export default "__VITE_ASSET__Cl9rFAOO__"